import {changeEvent, dispatchCustomEvent} from "../../../../../../../webpack/modules/events";
import {updatePriceElements, updateSizesPrices} from "../../../../../../../webpack/modules-optimized/product-list";
import {isDesktop} from "../../../../../../../webpack/modules/devices";

changeEvent('#product-list-page .product-configuration-pack[data-option-type="selectable"] input[name="pack"]', true, function(element) {
    let mainContainer = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration-pack');
    let previewElement = mainContainer.querySelector('.open-configuration .preview-option-pack');

    container.querySelectorAll('.pack.selected').forEach(option => option.classList.remove('selected'));
    element.nextElementSibling.classList.add('selected');
    mainContainer.querySelector('input[name="option-pack"]').value = element.value;
    dispatchCustomEvent(
        'productPackChanged',
        {
            'option': container,
            'previewElement': previewElement
        }
    );
    updatePriceElements(container);
    updateSizesPrices(container);
    container.dataset.completed = 'true';
    dispatchCustomEvent('productListProductConfigurationChanged');
});